<template>
  <div class="edit-modal-wrapper" v-if="order">
    <div class="edit-modal-backdrop"></div>

    <h3 class="edit-modal-header">{{ $t('edit.title') }}</h3>

    <div class="edit-modal-body" v-if="!addDish.active">
      <QueueItem 
        :order="order" 
        @changeQuantity="changeQuantity" 
        @appendChangeQuantity="changeAppendQuantity"/>

      <div class="edit-actions">
        <button class="btn-add" @click="showAddDishUI">
          <font-awesome-icon :icon="['fas', 'plus']" /> {{ $t('edit.add_dish') }}
        </button>

        <div class="edit-modal-actions">
          <QueueButton variant="cancel" @click="emitCancel">{{ $t('edit.cancel') }}</QueueButton>
          <QueueButton variant="accept" @click="emitConfirm">{{ $t('edit.save') }}</QueueButton>
        </div>
      </div>
    </div>

    <AddDishModal 
        @cancel="addDish.active = false"
        @add="handleAddDish"
        v-if="addDish.active"/>
  </div>
</template>

<script>
import QueueItem from "@/components/QueueItem.vue";
import QueueButton from "@/components/QueueButton.vue";

import AddDishModal from '@/components/modals/AddDish.vue'

export default {
  props: {
    initialOrder: Object,
  },
  data() {
    return {
      order: null,

      addDish: {
          active: false
      }
    };
  },
  methods: {
    changeQuantity(order_id, idx, value) {
      this.order.list[idx].quantity += value;

      if (this.order.list[idx].quantity <= 0) {
        this.order.list.splice(idx, 1);
      }
    },
    changeAppendQuantity(append_index, idx, value) {
      this.order.appends[append_index].list[idx].quantity += value;

      if (this.order.appends[append_index].list[idx].quantity  <= 0) {
        this.order.appends[append_index].list.splice(idx, 1);
      }
    },
    emitCancel() {
      this.$emit("cancel");
    },
    emitConfirm() {
      this.$emit("confirm", this.order);
    },
    showAddDishUI() {
        this.addDish.active = true;
    },
    handleAddDish(dish) {
        this.order.list.push(dish);

        this.addDish.active = false;
    }
  },
  mounted() {
    this.order = Object.assign({}, this.initialOrder);
    this.order.status = "editing";
  },
  computed: {
  },
  components: {
    QueueItem,
    QueueButton,
    AddDishModal
  }
};
</script>

<style scoped>
.edit-modal-wrapper {
  width: 100%;
  height: 100%;

  overflow: scroll;
}

.edit-modal-backdrop {
  position: fixed;
  width: 100%;
  height: 120px;
  top: 0;
  background: white;
  opacity: 1;
  z-index: 9;
}

.edit-modal-header {
  color: black;
  text-align: center;
  width: 100%;
  z-index: 9;
  top: 12px;
  position: fixed;

}

.edit-modal-actions {
  display: flex;
  justify-content: space-between;
  margin: 25px 0px;
}

.edit-actions {
    width: 90%;
    margin-left: 5%;
}

.edit-modal-body {
  border-radius: 40px;
  background: #ededed;
  position: fixed;
  overflow: auto;
  height:100%;
  top: 60px;
  z-index: 10;
  width: 100%;
}

.btn-add {
  width: 100%;
  font-size: 16px;
  margin-top: 20px;
  padding: 10px 0;
  outline: none;
  display: block;
  border-radius: 25px;
  background: transparent;
  border: 1px solid black;
}

</style>